import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { ICoreProductCategory } from "../types/core";

const API = process.env.REACT_APP_API;

/**
 * Payload para criação de categoria de produto
 */
export interface CreateCoreProductCategoryPayload {
  name: string;
  order?: number;
}

/**
 * Hook para criar uma categoria de produto (core.ProductCategory)
 */
const useCreateCoreProductCategory = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateCoreProductCategoryPayload) => {
      return fetch(`${API}/api/semeadora/core_product_categories/`, {
        method: "POST",
        body: data,
      }) as Promise<ICoreProductCategory>;
    },
    onSuccess: () => {
      // Invalidar cache da lista de categorias
      queryClient.invalidateQueries({ queryKey: ["core_product_categories"] });
    },
    onError: (error) => {
      console.error("Erro ao criar categoria de produto", error);
    },
  });
};

export default useCreateCoreProductCategory;
